import { Component, ChangeDetectionStrategy, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { SwitchThemeService, ThemeMode } from '../../services/switch-theme/switch-theme.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'ems-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ThemeToggleComponent implements OnInit {
  @ViewChild('themeMenu') themeMenu!: Menu;
  currentTheme$: Observable<ThemeMode>;
  themeMenuItems: MenuItem[] = [];

  constructor(private switchThemeService: SwitchThemeService) {
    this.currentTheme$ = this.switchThemeService.getCurrentTheme();
  }

  ngOnInit() {
    this.initializeMenuItems();
  }

  private initializeMenuItems(): void {
    this.themeMenuItems = [
      {
        label: 'Light',
        icon: 'pi pi-sun',
        command: () => this.setTheme('light'),
        styleClass: this.isActive('light') ? 'active' : ''
      },
      {
        label: 'Dark',
        icon: 'pi pi-moon',
        command: () => this.setTheme('dark'),
        styleClass: this.isActive('dark') ? 'active' : ''
      },
      {
        label: 'Auto',
        icon: 'pi pi-desktop',
        command: () => this.setTheme('auto'),
        styleClass: this.isActive('auto') ? 'active' : ''
      }
    ];
  }

  toggleThemeMenu(event: Event): void {
    // Update menu items to reflect current state
    this.updateMenuItems();
    
    // Show the menu
    this.themeMenu.toggle(event);
  }

  private updateMenuItems(): void {
  this.themeMenuItems.forEach(item => {
    item.styleClass = this.isActive(this.getLabelTheme(item.label || '')) ? 'active' : '';
  });
}

  private setTheme(theme: ThemeMode): void {
    this.switchThemeService.setTheme(theme);
    this.updateMenuItems();
  }

  private isActive(theme: ThemeMode): boolean {
    return this.switchThemeService.getCurrentThemeValue() === theme;
  }

  private getLabelTheme(label: string): ThemeMode {
    switch (label) {
      case 'Light':
        return 'light';
      case 'Dark':
        return 'dark';
      case 'Auto':
        return 'auto';
      default:
        return 'auto';
    }
  }

  getThemeIcon(): string {
    return this.switchThemeService.getThemeIcon();
  }

  getThemeDisplayName(): string {
    return this.switchThemeService.getThemeDisplayName();
  }
}